<template>
  <div>
    <p>刷新页面</p>
  </div>
</template>

<script>
  export default {
      name: "refresh",
      mounted() {
         this.$router.back();
      }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Refresh.vue